<template>
    <validation-observer
        tag="form"
        v-slot="{ handleSubmit }">
        <div class="px-4 mx-2">
            <section-title 
                class="mt-1 pt-3 mb-3"
                icon="fa fa-files-medical" 
                title="Crear Enmienda"
                title-class="font-14"/>
            <validation-provider            
                v-slot="{ errors }"
                rules="required">
                <custom-text-area 
                    :rows="1"
                    :maxlength="300"
                    :show-char-count="true"                               
                    :error="errors[0]"
                    v-model="amendReason"
                    custom-error-msg="La razón de enmienda es requerida."                    
                    label="Razón de enmienda:" 
                />
            </validation-provider>

            <div class="text-right pb-3 mt-1">
                <action-button
                    :i="`fas fa-times-circle`"
                    variant="outline-danger m-1 btn-block-xs-only"
                    text="Cancelar"
                    @click="onCancel()"
                />
                <action-button
                    i="fa fa-file-plus"
                    variant="success m-1 btn-block-xs-only"
                    text="Crear Enmienda"
                    @click="handleSubmit(onClick)"
                />
            </div>
        </div>
    </validation-observer>
</template>

<script>
import SectionTitle from "SectionTitle";
import ActionButton from "ActionButton";
import CustomTextArea from "CustomTextArea";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "EdenDetails",
  components: {
    SectionTitle,
    ActionButton,
    CustomTextArea,
    ValidationObserver,
    ValidationProvider,
  },
  props: {      
      item:{
          type: Object,
          default: ()=> {}
      }
  },
  data: () => ({       
    amendReason: null
  }),  
  methods: {
      onCancel(){
        this.$emit("on-cancel-amend");
      },
      async onClick(){
        this.$emit("on-create-amend", this.amendReason)                           
      }
  },
}
</script>